<template>
  <div class="body">
    <!--  筛选条件 -->
    <div class="navigation-line-top">
      <div class="navigation-line contents">
        <div class="contents navigation-contents">
          <p class="navigation">
            <i class="icon iconfont icon-yuanquan_huaban1"></i>
            <span class="nowshow">当前位置：</span>
            <router-link class="navigation-now" tag="a" :to="{ name: 'index' }"
              >首页</router-link
            >
            <i class="icon iconfont icon-youjiantou"></i>
            <router-link
              class="navigation-now"
              tag="a"
              :to="{ name: 'brandList' }"
              >品牌</router-link
            >
            <i class="icon iconfont icon-youjiantou"></i>
            <span
              class="navigation-now"
              v-if="brandInfoAll && brandInfoAll.bannerInfo"
              >{{ brandInfoAll.bannerInfo.bannerNmae }}</span
            >
          </p>
          <!-- 品牌列表 -->
          <Brandlist :brandId="brandId"></Brandlist>
          <brand-top
            :brandInfo="brandInfo"
            :otherInfo="brandInfoAll.bannerInfo"
          ></brand-top>
        </div>
      </div>
      <brand-navigation @tabItem="tabItem" ref="navigation"></brand-navigation>
    </div>
    <template v-if="activeItem == 2">
      <div class="navigation-line contents">
        <div class="search">
          <div class="title-right">
            <ul class="title-right-class">
              <li
                v-for="(classinfo, index) in brandClassList"
                :key="index"
                :class="{ titlerightclassli: classinfo.isChecked == true }"
                @click="checkClass(index)"
              >
                {{ classinfo.name }}
              </li>
            </ul>
            <div class="title-right-attr-box">
              <!--类型：-->
              <ul class="title-right-attr" v-if="secondClass.length > 0">
                <li class="title-right-attr-li">
                  <div class="title-right-attr-li-title">
                    {{ secondClass[0].attr ? secondClass[0].attr : "类型" }}：
                  </div>
                  <div class="title-right-attr-li-item">
                    <p class="title-right-attr-li-item-p">
                      <span
                        class="title-right-attr-li-item-line"
                        v-for="(classInfo, indexs) in secondClass"
                        :key="indexs"
                        @click="editSecondClass(indexs)"
                      >
                        <img v-if="classInfo.isChecked" :src="choose" /><img
                          v-else
                          :src="nochoose"
                        />
                        <span>{{ classInfo.name }}</span>
                      </span>
                    </p>
                  </div>
                </li>
              </ul>

              <!--结构形式：-->
              <ul class="title-right-attr" v-if="thirdClass.length > 0">
                <li class="title-right-attr-li">
                  <div class="title-right-attr-li-title">
                    {{ thirdClass[0].attr ? thirdClass[0].attr : "结构形式" }}：
                  </div>
                  <div class="title-right-attr-li-item">
                    <p class="title-right-attr-li-item-p">
                      <span
                        class="title-right-attr-li-item-line"
                        v-for="(classInfo, index) in thirdClass"
                        :key="index"
                        ><img v-if="classInfo.isChecked" :src="choose" /><img
                          v-else
                          :src="nochoose"
                        />
                        <span>{{ tclass.name }}</span>
                      </span>
                    </p>
                  </div>
                </li>
              </ul>
              <!--子分类end-->

              <!--属性列表-->
              <ul class="title-right-attr">
                <template v-for="(sclass, sindex) in attrList">
                  <li class="title-right-attr-li" v-if="sclass.name != '品牌'">
                    <div class="title-right-attr-li-title">
                      {{ sclass.name }}：
                    </div>
                    <div class="title-right-attr-li-item">
                      <p class="title-right-attr-li-item-p">
                        <span
                          class="title-right-attr-li-item-line"
                          v-for="(tclass, tindex) in sclass.options"
                          :key="tindex"
                          @click="checkitemClass(sindex, tindex)"
                        >
                          <img v-if="tclass.isChecked" :src="choose" />
                          <img v-else :src="nochoose" />
                          <span>{{ tclass.name }}</span>
                        </span>
                      </p>
                    </div>
                  </li>
                </template>
              </ul>
              <!--属性列表end-->
            </div>
            <div class="title-right-attr-span" @click="reset()">重置</div>
          </div>
        </div>
      </div>
      <!--  筛选条件结束 -->

      <!-- 商品列表 -->
      <div class="contents-goods-box" id="goodslist">
        <div class="contents">
          <div class="goods-box">
            <brand-goods
              :pagesize="pagesize"
              :iconon="iconon"
              :iconoff="iconoff"
              :where="goodsWhere"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-if="activeItem == 1">
      <!--关于我们-->
      <template v-if="brandInfoAll && brandInfoAll.aboutus && showSwiper == 1">
        <about-us
          :aboutus="brandInfoAll.aboutus"
          :aboutTitleWidth="brandInfoAll.aboutus.aboutTitleWidth"
        >
        </about-us>
      </template>

      <!--行业-->
      <template v-if="brandInfoAll && brandInfoAll.industrylist">
        <industry-list
          :aboutTitle="brandInfoAll.industryTitle"
          aboutTitleWidth="740px"
          :industryBj="industryBj"
          :industrylist="brandInfoAll.industrylist"
        ></industry-list>
      </template>

      <!--产品特点-->
      <template v-if="brandInfoAll && brandInfoAll.characteristic">
        <products-advantages
          :aboutTitle="brandInfoAll.productsTitle"
          aboutTitleWidth="849px"
          :characteristic="brandInfoAll.characteristic"
        ></products-advantages>
      </template>
      <!--其他品牌特点(人物，奖状)-->
      <template v-if="brandInfoAll && brandInfoAll.brandAdvantage">
        <brand-advantage
          :brandAdvantage="brandInfoAll.brandAdvantage"
        ></brand-advantage>
      </template>

      <!--普通商品产品优势 附带切换图-->
      <template
        v-if="
          brandInfoAll &&
            brandInfoAll.otherProductsAdvantages &&
            showSwiper == 1
        "
      >
        <other-products-advantages
          @tabMoreItem="tabMoreItem"
          :otherProductsAdvantages="brandInfoAll.otherProductsAdvantages"
          :type="type"
          :height="otherproductsadvantagesheight"
          :marginTopAndBottom="marginTopAndBottom"
        ></other-products-advantages>
      </template>

      <!--其他品牌行业-->
      <template v-if="brandInfoAll && brandInfoAll.pindustry">
        <other-industry-list
          :industryTitleImg="brandInfoAll.pindustry.industryTitleImg"
          :pindustry="brandInfoAll.pindustry.list"
        ></other-industry-list>
      </template>
      <!-- <template v-if="brandInfoAll && brandInfoAll.pindustry">
        <other-industry-list8
          :industryTitleImg="brandInfoAll.pindustry.industryTitleImg"
          :pindustry="brandInfoAll.pindustry.list"
        ></other-industry-list8>
      </template> -->

      <!--我们的服务-->
      <template v-if="brandInfoAll && brandInfoAll.services">
        <render-service
          :aboutTitle="brandInfoAll.servicesTitle"
          aboutTitleWidth="630px"
          :services="brandInfoAll.services"
        ></render-service>
      </template>
    </template>
  </div>
</template>

<script>
import BrandGoods from "../../components/brand/BrandGoods.vue";
import Brandlist from "../../components/brand/brandlist.vue";
import BrandTop from "../../components/brand/BrandTop.vue";
import BrandNavigation from "../../components/brand/BrandNavigation.vue";
import AboutUs from "../../components/brand/AboutUs.vue";
import IndustryList from "../../components/brand/IndustryList.vue";
import ProductsAdvantages from "../../components/brand/ProductsAdvantages.vue";
import RenderService from "../../components/brand/RenderService.vue";
import BrandAdvantage from "../../components/brand/BrandAdvantage.vue";
import OtherProductsAdvantages from "../../components/brand/OtherProductsAdvantages.vue";
import OtherIndustryList from "../../components/brand/OtherIndustryList.vue";
import OtherIndustryList8 from "../../components/brand/OtherIndustryList8.vue";

export default {
  data() {
    return {
      brandId: 1,
      ifstartvideo: true,
      brandClassList: [],
      firstClass: [],
      secondClass: [],
      thirdClass: [],
      attrList: [],
      brandInfo: {},
      showSwiper: 1,
      goodsWhere: {},
      activeItem: 1,
      isActive: "goodslist",
      choose: "/static/brand/choose.png",
      nochoose: "/static/brand/nochoose.png",
      pagesize: 20,
      iconon: "icon iconfont icon-shoucang1",
      iconoff: "el-icon-star-off",
      showindex: 1,
      industryBj: "/static/brand/bj/zy.jpg",
      industryTitle: "/static/brand/Vector.png",
      productsTitle: "/static/brand/advantage.png",
      servicesTitle: "/static/brand/service.png",
      pindustry: [],
      brandInfoAll: {
        metaInfo: {
          title: "",
          keywords: "",
          description: ""
        }
      },
      industryTitleImg: "",
      mVhtmlWidth: 1200,
      mVhtmlLeft: 0,
      mVhtmlScale: 1,
      type: 1,
      otherproductsadvantagesheight: 342,
      marginTopAndBottom: 0
    };
  },
  components: {
    BrandGoods,
    Brandlist,
    BrandTop,
    BrandNavigation,
    AboutUs,
    IndustryList,
    ProductsAdvantages,
    RenderService,
    BrandAdvantage,
    OtherProductsAdvantages,
    OtherIndustryList,
    OtherIndustryList8
  },
  methods: {
    getBrandInfoAll() {
      var res = this.$api.brand.getBrandInfo(this.brandId);
      this.brandInfoAll = res;
    },
    //获取品牌的分类
    getBrandClass() {
      this.$api.brand.getGoodsBrandClass(this.brandId).then(res => {
        this.brandClassList = res.data.datas.cidArr;
        this.collectClass();
        this.brandInfo = res.data.datas.brandInfo;
      });
    },
    editSecondClass(index) {
      var index1 = this.secondClass.findIndex(item => {
        if (item.isChecked == true) {
          return true;
        }
      });
      if (index1 > -1) {
        this.secondClass[index1].isChecked = false;
      }
      this.secondClass[index].isChecked = true;

      //更新父数组
      var index1 = this.brandClassList.findIndex(item => {
        if (item.isChecked == true) {
          return true;
        }
      });
      this.brandClassList[index1].son[index].isChecked = true;
      this.getGoodsAttr();
      this.getGoodslist();
      // var index2 = this.brandClassList[index1].son.findIndex((item) => {
      //   if (item.isChecked == true) {
      //     return true;
      //   }
      // });
    },
    //通过源数组整理子分类数组
    collectClass() {
      this.secondClass = [];
      this.thirdClass = [];
      //一级分类
      var index1 = this.brandClassList.findIndex(item => {
        if (item.isChecked == true) {
          return true;
        }
      });
      if (index1 == -1) {
        index1 = 0;
        this.brandClassList[index1].isChecked = true;
      }
      //二级分类
      if (
        this.brandClassList[index1].son &&
        this.brandClassList[index1].son[0]
      ) {
        var index2 = this.brandClassList[index1].son.findIndex(item => {
          if (item.isChecked == true) {
            return true;
          }
        });
        if (index2 == -1) {
          index2 = 0;
        }
        this.secondClass = this.brandClassList[index1].son;
        this.secondClass[index2].isChecked = true;
      }
      //三级分类
      if (
        this.secondClass.length > 0 &&
        this.secondClass[0].son &&
        this.secondClass[0].son[0]
      ) {
        var index3 = this.secondClass[index2].son.findIndex(item => {
          if (item.isChecked == true) {
            return true;
          }
        });
        if (index3 == -1) {
          index3 = 0;
          this.thirdClass = this.secondClass[index2].son;
          this.thirdClass[index3].isChecked = true;
        }
      }
    },
    //获取属性
    getGoodsAttr() {
      var index = this.brandClassList.findIndex(item => {
        if (item.isChecked == true) {
          return true;
        }
      });
      if (this.brandClassList[index].son == undefined) {
        var brandId = this.brandClassList[index].id;
      } else {
        var index1 = this.brandClassList[index].son.findIndex(item => {
          if (item.isChecked == true) {
            return true;
          }
        });
        var brandId = this.brandClassList[index].son[index1].id;
      }
      this.toGetGoodsAttr(brandId);
    },
    toGetGoodsAttr(id) {
      this.$api.goods.getgoodsattr(id).then(res => {
        //console.log(res)
        var mlist = res.data.datas;
        this.attrList = mlist;
        //this.savetag();
      });
    },

    tabItem(val) {
      this.activeItem = val;
      this.checkClass(0);
    },
    tabMoreItem() {
      this.activeItem = 2;
      this.$refs.navigation.setActive(2);
      this.checkClass(0);
    },

    //选择分类
    checkClass(index) {
      //console.log(this.brandClassList);
      for (var i in this.brandClassList) {
        this.brandClassList[i].isChecked = false;
        if (i + "" == index + "") {
          this.brandClassList[index].isChecked = true;
        }
      }
      //清空选择的属性
      for (var m in this.attrList) {
        for (var mm in this.attrList[m].options) {
          this.attrList[m].options[mm].isChecked = false;
        }
      }
      this.collectClass();
      //获取属性
      this.getGoodsAttr();
      this.getGoodslist();
    },
    //选择选项
    checkitemClass(sindex, tindex) {
      for (var j in this.attrList[sindex].options) {
        this.attrList[sindex].options[j].isChecked = false;
      }
      this.attrList[sindex].options[tindex].isChecked = true;
      this.getGoodslist();
    },
    //重置所有搜索条件
    reset() {
      for (var i in this.brandClassList) {
        for (var j in this.brandClassList[i].list) {
          for (var m in this.brandClassList[i].list[j].list) {
            this.brandClassList[i].list[j].list[m].isChecked = false;
          }
        }
      }

      for (var m in this.attrList) {
        for (var mm in this.attrList[m].options) {
          this.attrList[m].options[mm].isChecked = false;
        }
      }

      this.getGoodslist();
    },
    getGoodslist() {
      //整理条件
      this.goodsWhere = {};
      this.goodsWhere.attr = [];
      //一级分类
      var index = this.brandClassList.findIndex(item => {
        if (item.isChecked == true) {
          return true;
        }
      });
      // console.log(index);

      if (index !== -1) {
        if (this.brandClassList[index].level == 1) {
          this.goodsWhere.cid = this.brandClassList[index].id;
        } else if (this.brandClassList[index].level == 2) {
          this.goodsWhere.cid2 = this.brandClassList[index].id;
        } else if (this.brandClassList[index].level == 3) {
          this.goodsWhere.cid3 = this.brandClassList[index].id;
        }
      }

      //二级分类
      if (index !== -1 && this.brandClassList[index].son) {
        var index2 = this.brandClassList[index].son.findIndex(item => {
          if (item.isChecked == true) {
            return true;
          }
        });

        if (index2 !== -1) {
          if (this.brandClassList[index].son[index2].level == 1) {
            this.goodsWhere.cid = this.brandClassList[index].son[index2].id;
          } else if (this.brandClassList[index].son[index2].level == 2) {
            this.goodsWhere.cid2 = this.brandClassList[index].son[index2].id;
          } else if (this.brandClassList[index].son[index2].level == 3) {
            this.goodsWhere.cid3 = this.brandClassList[index].son[index2].id;
          }
        }
      }
      //查询属性
      for (var j in this.attrList) {
        for (var m in this.attrList[j].options) {
          if (this.attrList[j].options[m].isChecked) {
            this.goodsWhere.attr.push(this.attrList[j].options[m].id);
          }
        }
      }
      //添加分类搜索
      this.goodsWhere.brand_id = this.brandId;
    },
    getActive(val) {
      this.isActive = val;
      var offsetTop = document.querySelector("#" + val).offsetTop - 50;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }
  },
  metaInfo: {
    title: "阿童木机器人_Movibot品牌_工业机器人-并联机器人",
    meta: [
      {
        name: "keywords",
        content: "工业机器人_并联机器人_scara机器人_阿童木机器人"
      },
      {
        name: "description",
        content:
          "阿童木机器人是工业机器人领域的知名品牌，主要产品包括并联机器人,scara机器人等，致力于为食品、制药、日化等行业的集成商客户提供服务"
      }
    ]
  },
  watch: {
    $route(to, from) {
      //监听URL地址栏参数变化
      this.brandId = this.$route.params.id;
      if (this.brandId == 9 || this.brandId == 10) {
        this.type = 2;
      }

      if (this.brandId == 10) {
        this.otherproductsadvantagesheight = 390;
      }

      if (this.brandId == 9) {
        this.marginTopAndBottom = 20;
      }
      this.showSwiper = 2;
      this.getBrandInfoAll();
      this.getBrandClass();
      this.getGoodslist();
      this.activeItem = 1;
      this.$nextTick(function() {
        this.showSwiper = 1;
      });
      this.$refs.navigation.setActive(1);
    }
  },
  mounted() {
    this.brandId = this.$route.params.id;
    if (this.brandId == 9 || this.brandId == 10) {
      this.type = 2;
    }

    if (this.brandId == 10) {
      this.otherproductsadvantagesheight = 390;
    }

    if (this.brandId == 9) {
      this.marginTopAndBottom = 20;
    }

    this.getBrandInfoAll();
    this.getBrandClass();
    this.getGoodslist();
  },
  metaInfo() {
    return {
      title: this.brandInfoAll.metaInfo.title,
      meta: [
        { name: "keywords", content: this.brandInfoAll.metaInfo.keywords },
        {
          name: "description",
          content: this.brandInfoAll.metaInfo.description
        }
      ]
    };
  }
};
</script>

<style scoped>
.body {
  background-color: #f4f5f7;
  overflow: hidden;
}
.navigation-line {
  font-size: 16px;
  margin-top: 25px;
}
.navigation-line .navigation {
  color: #333333;
}
/* .navigation-line .navigation .navigation-now{
        color: #2655AE;
    } */
.navigation-line .search {
  margin-top: 20px;
  overflow: hidden;
  /* padding-bottom: 60px; */
}
.navigation-line .search .title-left {
  margin-top: 27px;
  width: 268px;
  padding: 0 5px;
  float: left;
}
.navigation-line .search .title-left .title-left-img {
  width: 100%;
  height: 125px;
  margin-bottom: 20px;
  background-color: #fff;
  text-align: center;
  box-shadow: 0px 0px 8px rgb(72 72 72 / 20%);
}
.navigation-line .search .title-left .title-left-img img {
  height: 100%;
}
.navigation-line .search .title-left .title-left-list {
  background-color: #fff;
  box-shadow: 0px 0px 8px rgba(72, 72, 72, 0.2);
  width: 100%;
  cursor: pointer;
}
.navigation-line .search .title-left .title-left-list p {
  font-size: 22px;
  color: #666666;
  height: 59px;
  line-height: 59px;
  padding-left: 15px;
}
.navigation-line .search .title-left .title-left-list ul li {
  height: 37px;
  line-height: 37px;
  padding-left: 15px;
  font-size: 16px;
  color: #666666;
}
.navigation-line .search .title-right {
  width: 1200px;
  float: right;
}
.navigation-line .search .title-right .title-right-class {
  overflow: hidden;
}
.navigation-line .search .title-right .title-right-class li {
  text-align: center;
  float: left;
  font-size: 16px;
  color: #666666;
  position: relative;
  padding: 6px 20px;
  cursor: pointer;
  margin-bottom: 2px;
  /* border-bottom: 5px solid #DBDBDB; */
}
.navigation-line .search .title-right .title-right-class li::after {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 2px;
  content: "";
  /* background-color: #DBDBDB; */
}

.navigation-line
  .search
  .title-right
  .title-right-class
  .titlerightclassli::after {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 2px;
  content: "";
  background-color: #fbb113;
}
/**筛选项 */
.navigation-line .search .title-right .title-right-attr:last-child {
  margin-bottom: 20px;
}
.navigation-line .search .title-right .title-right-attr .title-right-attr-li {
  overflow: hidden;
  padding-left: 14px;
  padding-top: 20px;
}

.navigation-line .search .title-right .title-right-attr-box {
  background-color: #fff;
  overflow: hidden;
}

.navigation-line
  .search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-title {
  width: 114px;
  float: left;
  line-height: 2;
  font-size: 14px;
  color: #666666;
}
.navigation-line
  .search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item {
  width: 1072px;
  float: right;
}
.navigation-line
  .search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item
  .title-right-attr-li-item-p {
  display: flex;
  flex-wrap: wrap;
  line-height: 2;
}
.navigation-line
  .search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item
  .title-right-attr-li-item-line {
  margin-right: 50px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666666;
  cursor: pointer;
}
.navigation-line
  .search
  .title-right
  .title-right-attr
  .title-right-attr-li
  .title-right-attr-li-item
  span {
  display: inline-block;
  word-wrap: break-word;
  white-space: normal;
  margin-left: 10px;
}
.title-right-attr-span {
  float: right;
  background: #fbb113;
  border-radius: 17px;
  color: #fff;
  width: 75px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  margin-top: 20px;
  cursor: pointer;
}
/**产品列表 */
.contents-goods-box {
  background-color: #f3f5f7;
  overflow: hidden;
}
.contents-goods-box .goods-box {
  width: 1200px;
  float: right;
  /* margin-top:78px; */
  margin-bottom: 50px;
}
.contents {
  overflow: hidden;
}
.navigation-line .search .title-left .title-left-list ul .active {
  background-color: #fbb113;
  color: #fff;
}
.navigation .icon-yuanquan_huaban1 {
  color: #fbb113;
}
.navigation {
  float: right;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.nowshow {
  color: #666;
}
.navigation-now {
  color: #888;
}
.navigation a:hover {
  color: #2655ae;
  text-decoration: underline;
}
.navigation-line-top {
  background-color: #fff;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/brand/index.vue